import { Button } from '@/components/ui/button'
import {
	Dialog,
	DialogContent,
	DialogDescription,
	DialogFooter,
	DialogHeader,
	DialogTitle,
} from '@/components/ui/dialog'
import { useTranslation } from 'react-i18next'

interface RemoveMemberDialogProps {
	isOpen: boolean
	name: string
	email: string
	onClose: () => void
	onConfirm: () => void
	isRemoving: boolean
}

export function RemoveMemberDialog({
	isOpen,
	name,
	email,
	onClose,
	onConfirm,
	isRemoving,
}: RemoveMemberDialogProps) {
	const { t } = useTranslation('common')
	return (
		<Dialog open={isOpen} onOpenChange={open => !open && onClose()}>
			<DialogContent showCloseButton={!isRemoving}>
				<DialogHeader>
					<DialogTitle>{t('removeMember.title')}</DialogTitle>
					<DialogDescription>
						{t('removeMember.confirmMessage', { name, email })}
					</DialogDescription>
				</DialogHeader>
				<p className="text-muted-foreground text-sm">
					{t('removeMember.warning')}
				</p>
				<DialogFooter>
					<Button variant="outline" onClick={onClose} disabled={isRemoving}>
						{t('common.cancel')}
					</Button>
					<Button variant="destructive" onClick={onConfirm} disabled={isRemoving}>
						{isRemoving
							? t('removeMember.removing')
							: t('removeMember.removeButton')}
					</Button>
				</DialogFooter>
			</DialogContent>
		</Dialog>
	)
}
